import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';

import { StringUtils } from '../../../../utils/string-utils';

export interface faq {
  pergunta: string;
  resposta: string;
}

@Component({
  selector: 'faq-novo',
  templateUrl: './faq-novo.component.html',
  styleUrls: ['./faq-novo.component.scss'],
})
export class FaqNovoComponent implements OnInit, OnChanges {
  @Input() public faq: faq[] = [];
  @Input() public numerado: boolean = false;
  @Input() public tipo: number = 3;
  // 1 - Logado, 2- Não logado, 3 - Todos
  @Input() public verMais: boolean = false;
  @Input() public quantidadePorVerMais: number = 5;
  @Input() public filtro: string = '';

  public quantidadePerguntas: number = 7;
  private privateFaq: faq[] = [];

  constructor() {}

  ngOnInit(): void {
    this.privateFaq = this.faq;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filtro'] === undefined) return;
    if (!changes['filtro'].firstChange) {
      this.faq = _.filter(this.privateFaq, (pergunta: any) => {
        return (
          this.filtro === '' ||
          StringUtils.normalizarTexto(pergunta.pergunta).includes(
            StringUtils.normalizarTexto(this.filtro)
          )
        );
      });
    }
  }

  definirTitulo(pergunta: string, index: number): string {
    index++;

    let titulo: string = '';

    if (this.numerado) titulo += index + '. ';

    titulo += pergunta;

    return titulo;
  }

  public onClickVerMais(): void {
    this.quantidadePerguntas += this.quantidadePorVerMais;
  }
}
